<script>
import TheMenu from './TheMenu';

const PageWrapper = context => (
  <div>
    <TheMenu />

    <main class={context.$style.container}>
      {context.children}
    </main>
  </div>
);

export default PageWrapper;
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.container {
  margin: 0 auto;
  max-width: 960px;
  padding: 0 2 * $u-base-indent 2em;
}
</style>
